<template>
  <div class="container">
    <template v-if="list && list.length">
      <div class="container_item" v-for="(file, index) in list" :key="index">
        <el-image
                v-if="file.isImage"
                ref="elImage"
                class="elImage"
                :src="file.tagIm"
                :preview-src-list="getPrivewImages(index)"
        />
        <img v-if="!file.isImage" class="elImage" :src="file.tagIm" />
        <p class="content">{{ file.name }}</p>
        <div class="more">
          <span class="" @click="previewFile(file)"> 查看 </span>
          <span class="" @click="detelFile(file)" > 删除 </span>
        </div>
      </div>
    </template>
    <div v-else>
      暂无，请点击上传附件
    </div>
  </div>
</template>

<script>
import {
  getFileTypeImagebyExtName,
  getFileTypebyExtName,
} from "../../../utils/utils";
// import saasconfig from "@/config/config";
import config from "@/config/config.js";

export default {
  name: "FilePreviewLIst",
  props: ["fileList", "showDelte"],
  watch: {
    fileList: {
      //fileID集合
      handler: function (newData, oldData) {
        this.handleList();
      },
    },
  },
  data() {
    return {
      list: [],
      imgPreviewList: [],
    };
  },
  created() {
    this.handleList();
  },
  methods: {
    getPrivewImages(index) {
      let tempImgList = [...this.imgPreviewList]; //所有图片地址
      if (index == 0) return tempImgList;
      // 调整图片顺序，把当前图片放在第一位
      let start = tempImgList.splice(index);
      let remain = tempImgList.splice(0, index);
      return start.concat(remain); //将当前图片调整成点击缩略图的那张图片
    },
    previewFile(item) {
      console.log(item);
      if (item.isImage) {
        this.imgPreviewList.forEach((preBean, index) => {
          if (preBean.indexOf(item.fileId) !== -1) {
            this.$refs.elImage[index].clickHandler();
          }
        });
      } else window.open(item.previewUrl);
    },
    handleList() {
      if (this.fileList) {
        this.imgPreviewList = [];
        this.fileList.fileInfo.id = this.fileList.id;
        this.list = [];
        for (let item of this.fileList.fileInfo) {
          let isImage = getFileTypebyExtName(item.fileId) === 3;
          let resData = {};
          resData.name = item.fileName;
          resData.tagIm = getFileTypeImagebyExtName(item.fileName);
          resData.isImage = isImage;
          resData.previewUrl = `${config.baseURL}/gzzc/docBook/previewImg/${item.fileId}`;
          resData.fileId = item.fileId;
          resData.id = this.fileList.fileInfo.id;
          if (isImage) {
            this.imgPreviewList.push(
              `${config.baseURL}/gzzc/docBook/previewImg/${item.fileId}`
            );
          }
          this.list.push(resData);
        }
      }
    },
    detelFile(item) {
      this.$confirm("此操作将删除证据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.list.map((val, i) => {
          console.log(val, i);
          if (val.fileId === item.fileId) {
            this.list.splice(i, 1);
          }
          if (this.list.length <= 0) {
            this.$emit("close", item);
          }
        });

        this.$emit("detelEvidenceFile", item);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-flow: column;
  .container_item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 20px;
    height: 60px;
    line-height: 40px;
    font-size: 14px;
    .elImage {
      width: 40px;
      height: 40px;
      border-radius: 5px;
      margin: 20px;
    }
    .content {
      text-align: left;
      font-size: 14px;
      flex: 1;
      word-break: break-all;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .more {
      width: 100px;
      span {
        color: #0083c8;
        cursor: pointer;
        &:nth-child(2) {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
